import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import scenarioOneReducer from "./scenarioOne";
import scenarioTwoReducer from "./scenarioTwo";
import reduceStormOptionsOne from "./stormOptionsOne";
import reduceStormOptionsTwo from "./stormOptionsTwo";

const rootReducer = combineReducers({
 // add reducer functions here
 scenarioOne: scenarioOneReducer,
 scenarioTwo: scenarioTwoReducer,
 stormOptionsOne: reduceStormOptionsOne,
 stormOptionsTwo: reduceStormOptionsTwo,
});

let enhancer;

if (process.env.NODE_ENV === "production") {
 enhancer = applyMiddleware(thunk);
} else {
 const logger = require("redux-logger").default;
 const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
 enhancer = composeEnhancers(applyMiddleware(thunk, logger));
}

const configureStore = (preloadedState) => {
 return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
